/* eslint-disable no-loop-func */
import React from 'react';
import { useAccomodationDiagram } from './AccomodationDiagramContext';
import { Button, Divider, Stack, Tooltip, Typography } from '@mui/material';
import FemaleIcon from '@mui/icons-material/Female';
import MaleIcon from '@mui/icons-material/Male';
import toast from 'react-hot-toast';

import { calculateAge } from '../../../services/functions';
import { OrderContextMenu } from './context-menu/OrderContextMenu';
import { useReactFlow } from '@xyflow/react';

export const LeftSidebar = ({ closeDiagram }) => {
  const { setOrder, orders, setShowOrderDetails, savingDisabled, nodes, selectedAccomodationDiagram, events } = useAccomodationDiagram();
  const { setCenter } = useReactFlow();
  const [orderContextMenu, setOrderContextMenu] = React.useState(null);
  const [nodesToFocus, setNodesToFocus] = React.useState([]);
  const [currentFocusedNodeIndex, setCurrentFocusedNodeIndex] = React.useState(0);

  const onDragStart = (event, order) => {
    setOrder(order);
    event.dataTransfer.effectAllowed = 'move';
  };


  const handleOrderContextMenu = (event, order) => {
    event.preventDefault();
    setOrder(order);
    setOrderContextMenu(
      orderContextMenu === null
        ? {
          mouseX: event.clientX - 2,
          mouseY: event.clientY - 4,
          order
        }
        : null
    );
  };

  const focusNode = () => {
    if (nodesToFocus.length > 0) {
      // Znajdź aktualny BedNode do wycentrowania
      let currentNode = nodesToFocus[currentFocusedNodeIndex];
      if (!currentNode) {
        setCurrentFocusedNodeIndex(0);
        currentNode = nodesToFocus[0];

      }
      // Oblicz współrzędne absolutne zaczynając od BedNode
      let absoluteX = currentNode.position.x;
      let absoluteY = currentNode.position.y;

      // Iteracyjnie dodawaj współrzędne rodziców aż do AgeRangeNode
      let parentId = currentNode.parentId;
      while (parentId) {
        const parentNode = nodes.find(n => n.id === parentId);
        if (parentNode) {
          absoluteX += parentNode.position.x;
          absoluteY += parentNode.position.y;
          parentId = parentNode.parentId; // Przejdź do kolejnego rodzica
        } else {
          break; // Jeśli nie znajdziesz rodzica, przerwij
        }
      }
      // Ustaw widok na obliczone współrzędne
      setCenter(absoluteX + 150, absoluteY + 50, {
        zoom: 2.5, // Poziom przybliżenia
        duration: 800 // Animacja w milisekundach
      });
      // Przejdź do kolejnego BedNode
      setCurrentFocusedNodeIndex(prevIndex => prevIndex + 1);
    } else {
      toast.error('Nie znaleziono żadnych zamówień ze zmienionymi uwagami do zakwaterowania');
    }
  };

  function findGroupColorById(groupId) {
    for (const event of events) {
      for (const group of event.groups) {
        if (group.id === groupId) {
          return group.color;
        }
      }
    }

    return null;
  }

  const getEventName = order => {
    const truncateName = name => name.length > 20 ? `${name.slice(0, 20)}...` : name;

    return (
      <Typography color="default" variant="body25">
        <i>&nbsp;{truncateName(order.event__name)}</i>
      </Typography>
    );
  };

  React.useEffect(() => {
    setNodesToFocus(nodes.filter(n => n.data.order?.shared_accommodation_changed));
    setCurrentFocusedNodeIndex(0);
  }, [nodes]);


  return (
    <aside style={{ height: '80vh' }}>
      <Stack sx={{ height: '80vh' }} spacing={1}>
        <Button size="small" variant="contained" onClick={closeDiagram}>Zamknij diagram</Button>
        <Button size="small" variant="contained" onClick={focusNode}>Pokaż łóżka ze zmienionymi uwagami do zakwaterowania</Button>
        {/* <Button size="small" variant="contained" onClick={() => setRecalculateAllHouses(true)}>Wypozycjonuj</Button> */}
        <Typography variant="subtitle1" align="center" mb={1}>
            Lista robocza niezakwaterowanych osób
        </Typography>
        <Divider />
        <Stack sx={{ overflow: 'auto' }}>
          {orders && orders.filter(o => o.temporary).map((order, key) => (
            <div
              key={key}
              className="dndnode"
              onDragStart={event => onDragStart(event, order)}
              draggable
              onClick={() => {
                setShowOrderDetails(order);
                setOrder(order);
              }}
              onContextMenu={event => handleOrderContextMenu(event, order)}
              style={order.relatedGroup ? { border: `3px solid ${order.relatedGroup.color}` } : {}}
            >

              <Tooltip title={order.agreement_number} sx={{ ml: 1 }}>
                <Stack direction="column">
                  <Stack direction="row">
                    {order.participant_gender === 'boy' ? <MaleIcon /> : <FemaleIcon />}
                    {order.shared_accommodation_changed && <Typography color="red"><b>!</b></Typography>}

                    <Stack direction="row" spacing={0.5}>
                      <Typography variant="body2" color="red">{order.accommodation_prefix}</Typography>
                      <Typography variant="body2" color={findGroupColorById(order.accommodation_event_group)}><b>{order.participant_name}</b></Typography>
                    </Stack>
                  </Stack>
                  <Stack direction="row" alignItems="center" >
                    <Typography variant="body25"><i>{calculateAge(order.participant_birth_date, false, selectedAccomodationDiagram.camp_date_from)}</i></Typography>
                    {getEventName(order)}
                  </Stack>
                </Stack>
              </Tooltip>
            </div>
          ))}
        </Stack>
      </Stack>
      { orderContextMenu && !savingDisabled && <OrderContextMenu contextMenu={orderContextMenu} closeContextMenu={() => setOrderContextMenu(null)} />}
    </aside>
  );
};
